/* tslint:disable */

declare var Object: any;
export interface SFPolicyInterface {
  "id"?: number;
}

export class SFPolicy implements SFPolicyInterface {
  "id": number;
  constructor(data?: SFPolicyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFPolicy`.
   */
  public static getModelName() {
    return "SFPolicy";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFPolicy for dynamic purposes.
  **/
  public static factory(data: SFPolicyInterface): SFPolicy{
    return new SFPolicy(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFPolicy',
      plural: 'SFPolicies',
      path: 'SFPolicies',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFPolicy.ts